import { Dispatch } from 'redux';

import { categoryActions } from '../../store/modules/category';
import { templateActions } from '../../store/modules/template';
import { videoActions } from '../../store/modules/video';

import dispatchCurrentTemplate, {
  TemplateListQuery
} from './dispatchCurrentTemplate';
import getTemplateFiltersByQuery from './getTemplateFiltersByQuery';

type DispatchGetInitialProps = {
  query: TemplateListQuery;
  dispatch: Dispatch;
};

export default ({ query, dispatch }: DispatchGetInitialProps) => {
  dispatch(
    templateActions.fetchTemplateListByFilter(getTemplateFiltersByQuery(query))
  );
  dispatch(videoActions.getVideoFormats());
  dispatch(categoryActions.getCategoryList());
  dispatchCurrentTemplate({ query, dispatch });
};
